module.exports = __webpack_public_path__ + "img/wallpaper-dark.9f332468.jpg";